/* Accessible disclosure navigation. Never intercept native department links. */
(() => {
  function initializeHeader(header) {
  if (!header || header.dataset.ithHeaderReady) return;
  header.dataset.ithHeaderReady = 'true';
  const controller = new AbortController();
  const signal = controller.signal;
  header.ithHeaderController = controller;
  const items = [...header.querySelectorAll('.ith-nav-item')];
  let opened = null;
  let pinned = null;
  const desktop = matchMedia('(min-width: 1200px)');
  function close(item, restoreFocus = false) {
    if (!item) return;
    item.classList.remove('ith-open');
    const button = item.querySelector('.ith-nav-toggle');
    const panel = item.querySelector('.ith-menu');
    if (button) button.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
    if (opened === item) opened = null;
    if (pinned === item) pinned = null;
    if (restoreFocus && button) button.focus();
  }
  function open(item) {
    if (!desktop.matches || !item.querySelector('.ith-menu')) return;
    if (opened && opened !== item) close(opened);
    opened = item;
    item.classList.add('ith-open');
    item.querySelector('.ith-nav-toggle').setAttribute('aria-expanded', 'true');
    item.querySelector('.ith-menu').hidden = false;
  }
  items.forEach(item => {
    const button = item.querySelector('.ith-nav-toggle');
    if (!button) return;
    item.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'touch') open(item);
    });
    item.addEventListener('pointerleave', () => {
      if (!item.contains(document.activeElement)) close(item);
    });
    button.addEventListener('click', () => {
      if (opened === item && pinned === item) close(item);
      else {
        open(item);
        pinned = item;
      }
    });
    item.querySelector('.ith-menu-close').addEventListener('click', () => close(item, true));
    item.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' && event.target.closest('.ith-nav-trigger')) {
        event.preventDefault();
        open(item);
        item.querySelector('.ith-menu a').focus();
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        close(item, true);
      }
    });
    item.addEventListener('focusout', event => {
      if (!item.contains(event.relatedTarget)) close(item);
    });
  });
  document.addEventListener('click', event => {
    if (opened && !opened.contains(event.target)) close(opened);
  }, { signal });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && opened) close(opened, true);
  }, { signal });
  const drawer = header.querySelector('#drawer');
  const menuOpen = header.querySelector('#menuOpen');
  const drawerClose = header.querySelector('#drawerClose');
  function closeDrawer() {
    const wasOpen = drawer.classList.contains('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    menuOpen.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (wasOpen && !desktop.matches) menuOpen.focus();
  }
  menuOpen.addEventListener('click', () => {
    close(opened);
    drawer.inert = false;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    menuOpen.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    drawerClose.focus();
  });
  drawerClose.addEventListener('click', closeDrawer);
  header.querySelector('#drawerScrim').addEventListener('click', closeDrawer);
  header.querySelectorAll('.acc-head').forEach(button => {
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', () => {
      const expanded = button.parentElement.classList.toggle('open');
      button.setAttribute('aria-expanded', String(expanded));
    });
  });
  document.addEventListener('keydown', event => {
    if (!drawer.classList.contains('open')) return;
    if (event.key === 'Escape') closeDrawer();
    if (event.key === 'Tab') {
      const elements = [...drawer.querySelectorAll('a[href],button,input')].filter(el => el.getClientRects().length);
      const first = elements[0], last = elements.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    }
  }, { signal });
  desktop.addEventListener('change', () => {
    close(opened);
    if (desktop.matches) closeDrawer();
  }, { signal });
  // Native product/cart scripts replace this link's contents after AJAX cart changes.
  // Preserve their hooks and announce the updated item count without a second cart API.
  const cartLink = header.querySelector('.ith-tool-cart');
  const syncCartLabel = () => {
    const count = cartLink.querySelector('.ith-cart-count')?.textContent.trim() || '0';
    cartLink.setAttribute('aria-label', `Cart, ${count} items`);
  };
  const observer = new MutationObserver(syncCartLabel);
  observer.observe(cartLink, { childList: true, subtree: true, characterData: true });
  signal.addEventListener('abort', () => observer.disconnect());
  const updateHeight = () => {
    if (document.body.classList.contains('gradient')) {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }
  };
  const resize = new ResizeObserver(updateHeight);
  resize.observe(header);
  signal.addEventListener('abort', () => resize.disconnect());
  syncCartLabel();
  }
  initializeHeader(document.querySelector('.ith-site-header'));
  document.addEventListener('shopify:section:load', event => {
    initializeHeader(event.target.querySelector('.ith-site-header'));
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelector('.ith-site-header')?.ithHeaderController?.abort();
  });
})();
